import { FETCH_SITE_COMMENTS } from 'actions';

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_SITE_COMMENTS:
            return action.payload;
        default:
            return state;
    }
};